import { render, staticRenderFns } from "./tizhibianshi.vue?vue&type=template&id=7926fc26&"
import script from "./tizhibianshi.vue?vue&type=script&lang=ts&"
export * from "./tizhibianshi.vue?vue&type=script&lang=ts&"
import style0 from "./tizhibianshi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports